export const HEADER = 'header';
export const LAST_CHANCE = 'lastChance';
export const PICKS_FOR_YOU = 'picksForYou';
export const POPULAR_CATEGORIES = 'popularCategories';
export const CAROUSEL = 'carousel';
export const RECENTLY_VIEWED = 'recentlyViewed';
export const INSTAGRAM_FEED = 'instagramPosts';
export const WISH_LIST = 'wishList';
export const FAVOURITE_SELLERS = 'favouriteSellers';
